import styled from "@emotion/styled/macro";

const IconButton = styled<"button", { icon: string }>("button")`
  border: none;
  background: none;
  width: 55px;
  height: 55px;
  background: url(${({ icon }) => icon}) no-repeat center center;
  background-size: 30px;
`;

export default IconButton;
